<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <div class="title" v-if="getModalData.id">Edit Station</div>
        <div class="title" v-if="!getModalData.id">Add Station</div>
      </h5>
      <button type="button" class="close" @click="$store.dispatch('closeModal', true)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form class="form" @submit.prevent="onSubmit">
<!--        <div class="form-group">-->
<!--          <label>Number</label>-->
<!--          <input type="text" class="form-control" v-model="form.number"/>-->
<!--        </div>-->
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" v-model="form.name"/>
        </div>
        <div class="form-group" v-if="!thirdParty">
          <label>Map station</label>
          <div class="custom-file">
            <input type="file" class="custom-file-input" id="customFile" ref="map" @change="filename = $refs.map.files[0].name">
            <label class="custom-file-label" for="customFile">{{ filename }}</label>
          </div>
          <a :href="this.getModalData.map" v-if="this.getModalData.map">Current map file</a>
        </div>
        <div class="form__btn position-relative">
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Save</span>
          </b-button>
          <b-button variant="primary" class="mb-2 btn-delete float-right position-absolute" style="top: 0; right: 0;" v-if="getModalData.id" @click="onDelete">
            <b-icon icon="trash" aria-label="Delete"></b-icon>
          </b-button>
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="!getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Add</span>
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions, mapMutations} from 'vuex'

  export default {
    name: 'ModalStation',
    computed: {
      ...mapGetters([
        'getModalData',
      ]),
    },
    data() {
      return {
        form: {
          // number: '',
          name: '',
        },
        filename: null,
        thirdParty: null
      }
    },
    mounted() {

      if (this.getModalData.third_party) this.thirdParty = 1
      if (this.getModalData.id) {
        this.form = {
          // number: this.getModalData.number,
          name: this.getModalData.name
        }
      }
    },
    methods: {
      ...mapActions([
        'storeStation',
        'updateStation',
        'destroyStation',
        'setToast',
        'closeModal',
      ]),
      ...mapMutations([
        'setStation'
      ]),
      onSubmit() {
        let formData = new FormData()
        formData.append('name', this.form.name)
        this.thirdParty ? formData.append('third_party', 1) : this.$refs.map.files[0] ? formData.append('map', this.$refs.map.files[0]) : console.log('no file')
        if (this.getModalData.id) {
          formData.append('_method', 'PATCH')
          this.updateStation([this.getModalData.id, formData])
        } else {
          this.storeStation(formData)
        }
      },
      onDelete() {
        this.$confirm({
          message: 'Delete stations ' + this.getModalData.name + ' and its platforms?',
          callback: confirm => {
            if (confirm) {
              this.destroyStation({id: this.getModalData.id, third_party: this.thirdParty})
              this.closeModal(true)
              this.setStation({})
            }
          }
        })
      }
    }
  }
</script>

<style>

</style>